import React, { useState } from 'react';
import { Container, Box, Typography, Link } from '@mui/material';
import { postPasswordResetMail } from '../../api/authentication';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input';
import Grid from '@mui/material/Grid2';

const PasswordResetByUser = () => {
  const [email, setEmail] = useState('');
  const [emailText, setEmailText] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = await postPasswordResetMail(email);
      if (data.email === 'Invalid') {
        setEmailText('Please check your email address');
        setEmail('');
      }
      if (data.email === 'Password reset email sent.') {
        navigate('/login');
      }
      if (data.email === 'Password was changed only recently.') {
        setEmailText(data.email);
      }
      if (data.email === 'Account is disabled') {
        setEmailText('Account is disabled');
      }

      if (data.email) {
        setEmailText(data.email);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} className="authentication-container">
          <Grid size={8} className="authentication-container-inner">
            <div className="authentication-header">Password Reset</div>

            <form onSubmit={handleSubmit} id="authentication-form" className="password-reset">
              <Typography>
                Enter your registered email address then check your email inbox including spam folders.
              </Typography>
              <Input name="username" type="text" label="Email Address" value={email} onChange={handleEmailChange} />

              {emailText && <Box sx={{ color: 'error.main', marginBottom: '20px' }}>{emailText}</Box>}

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <Link onClick={handleBack} variant="body2" className="authentication-button-back">
                    Back
                  </Link>
                </div>
                <button className="authentication-button" style={{ marginRight: 0 }} onClick={handleSubmit}>
                  Continue to reset
                </button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>
    </Container>
  );
};

export default PasswordResetByUser;
